/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  HeaderContainer,
  AgentDetails,
  FinanceType,
  HeaderTitleInner,
  LogoutButton,
  ShowName,
  HideName
} from "./styled";
import {
  getCompanyName,
  getFinanceType,
  getApplicantFullName,
  getAgentName
} from "../../store/selectors/appConfig";
import { checkLoginStatus, getAgentId, getRoCode } from "../../store/selectors/loginSelector";
import { logout } from "../../store/actions/loginForm";
import { getIsEditableStatusSearchInfo } from "../../store/selectors/searchProspect";
import { applicationOverviewRoutes } from "../../constants";
import routes from "../../routes";

const HeaderTitleComponent = ({
  title = "",
  financeType,
  companyName,
  applicantName,
  isComeFromROScreens,
  isAgent,
  agentName,
  roCode,
  agentId,
  displayAgentDetails = true,
  logout
}) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const selectedFinanceTypeName = financeType;

  const agentLogout = useCallback(() => {
    logout({ agentId });
    navigate(routes.login);
  }, [logout, navigate]);

  // Extract nested ternary into a function to render title content
  const renderTitleContent = () => {
    if (title) {
      if (selectedFinanceTypeName === undefined) {
        return <ShowName>{title}</ShowName>;
      } else {
        return <HideName>{title}</HideName>;
      }
    } else {
      return (
        <span>
          {!applicationOverviewRoutes.includes(pathname) && selectedFinanceTypeName && (
            <>
              <FinanceType component="span">
                {selectedFinanceTypeName}&nbsp;
                {selectedFinanceTypeName ? <>Finance </> : ""}
              </FinanceType>
              {renderApplicantOrCompany()}
            </>
          )}
        </span>
      );
    }
  };

  // Extract nested ternary operation into a separate function
  const renderApplicantOrCompany = () => {
    if (isComeFromROScreens && applicantName) {
      return <b>{applicantName}</b>;
    }
    if (companyName) {
      return <> for {companyName}</>;
    }
    return null;
  };

  return (
    <HeaderContainer>
      <HeaderTitleInner>
        {displayAgentDetails && isAgent && agentName !== undefined && (
          <AgentDetails>
            <div>
              {agentName} - {roCode}
            </div>
            <LogoutButton onClick={() => agentLogout()}>Logout</LogoutButton>
          </AgentDetails>
        )}
        {renderTitleContent()}
      </HeaderTitleInner>
    </HeaderContainer>
  );
};

const mapStateToProps = state => ({
  agentName: getAgentName(state),
  agentId: getAgentId(state),
  isAgent: checkLoginStatus(state),
  financeType: getFinanceType(state),
  companyName: getCompanyName(state),
  applicantName: getApplicantFullName(state),
  isComeFromROScreens: getIsEditableStatusSearchInfo(state),
  roCode: getRoCode(state)
});

const mapDispatchToProps = {
  logout
};

HeaderTitleComponent.propTypes = {
  title: PropTypes.string,
  financeType: PropTypes.string,
  companyName: PropTypes.string,
  applicantName: PropTypes.string,
  isComeFromROScreens: PropTypes.bool,
  isAgent: PropTypes.bool,
  agentName: PropTypes.string,
  roCode: PropTypes.string,
  displayAgentDetails: PropTypes.bool,
  logout: PropTypes.func.isRequired,
  agentId: PropTypes.string
};

export const HeaderTitle = connect(
  mapStateToProps,
  mapDispatchToProps
)(HeaderTitleComponent);
